import React, { useEffect, useRef, useState, Fragment  } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import SearchBannerNew from "../../../../Components/SearchBannerNew";
import { agencyHasFeature, isAgencyAdmin, isAgencyUser, token, user } from "../../../../modules/auth";
import { agencyObject, canAccessCorporateCalendar, isHeadOfEvents, isHeadOfProcurement } from "../../../../modules/permissions";
import { AGENCY_PERMISSIONS } from "../../../../constants";
import AgencyWelcomePanel from "../../AgencyEdge/Welcome/AgencyWelcomePanel";

let CorporateWelcome = ({
                      selectedAgencies,
                      agency,
                      user,
                      isAgencyAdmin,
                      showSnapshot,
                      canAccessCorporateCalendar,
                     }) => {

  const [agencies, setAgencies] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    if (Array.isArray(selectedAgencies) && selectedAgencies.length > 0) {
      let otherAgencies = selectedAgencies.map(a => ({
        id: a.id,
        name: a.name,
      }));
      const agencyExists = otherAgencies.some(a => a.id === agency.id);
      if (agencyExists) {
        otherAgencies = otherAgencies.filter(a => a.id !== agency.id);
        setAgencies([agency, ...otherAgencies]);
      } else {
        setAgencies([...otherAgencies]);
      }
    } else {
      setAgencies([agency]);
    }
  }, [selectedAgencies]);

  useEffect(() => {
    if (showSearch && searchRef.current) {
      searchRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [showSearch]);

  const getWelcomeMessage = () => {
      return (
        <>

        </>
      );
  };
  return (
    <Fragment>
      <div
        className="m-0 xxl:py-16 xxl:px-16 p-8 corporate-admin__dashboard__hero"
        style={{
          backgroundImage: "url(/img/corp-edge-reports-bg-blue-darker.jpg)",
          backgroundPosition: "0 ",
          backgroundSize: "cover",
          width: "100vw",
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
          borderBottom: "8px solid var(--primary-light)",
          borderColor: 'var(--primary-light) !important',
          backgroundColor: 'var(--primary-light) !important'
        }}
      >
          <div className="container flex justify-center pt-6 pb-4 md:pt-10 md:pb-6">
            <div className="col col-w-full flex-grow relative">
              <h1 className="text-shadow mb-4 text-white font-bold font-heading text-2rem md:text-5xl">
                Welcome to EDGE Venues, {user.first_name}
              </h1>
              <h4 className="text-shadow mb-4 text-white font-heading text-1rem md:text-2xl">
                Your complete venue and destination sourcing platform
              </h4>

              <div className="container ">
                <div className="row py-0 lg:py-4">
                  {showSnapshot ?
                    <div className={`col ${canAccessCorporateCalendar ? 'col-w-1/2' : 'col-w-full'} py-4 lg:py-0 mb-4 md:mb-0`}>
                      <AgencyWelcomePanel
                        to="/dashboard"
                        image="/img/agency-welcome/corporate-welcome-images-wider-hop-noslant.jpg"
                        subtitle="Stay organised, track progress, be in control"
                        title="Your Reporting"
                        height={'300px'}
                      />
                    </div> :
                    <div className={`col ${canAccessCorporateCalendar ? 'col-w-1/2' : 'col-w-full'} py-4 lg:py-0 mb-4 md:mb-0`}>
                      <AgencyWelcomePanel
                        to="/dashboard"
                        image="/img/agency-welcome/corporate-welcome-images-wider-noslant.jpg"
                        subtitle="Head to your personal dashboard space"
                        title="My EDGE"

                      />
                    </div>
                  }
                  {canAccessCorporateCalendar && (
                    <div className={`col ${canAccessCorporateCalendar ? 'col-w-1/2' : 'col-w-full'} py-4 lg:py-0 mb-4 md:mb-0`}>
                      <AgencyWelcomePanel
                        to="/corporate/calendar"
                        image="/img/agency-welcome/corporate-welcome-images--calendar.jpg"
                        subtitle="View your company events"
                        title="Company Calendar"
                        height={'300px'}
                      />
                    </div>

                  )}
                </div>
                <div style={{ backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '4px' }} className="py-4 px-4 md:w-1/2 text-white font-bold font-heading text-2xl md:text-4xl">Start your event journey the way you wish…</div>
                <div className="row py-0 lg:py-4">
                  <div className="col col-w-full lg:col-w-1/2 mb-4 md:mb-0">
                    <AgencyWelcomePanel
                      to="#"
                      image="/img/agency-welcome/agency-welcome-images--search.jpg"
                      subtitle="Find, shortlist, share your venues"
                      title="Search for Venues & UK Destinations"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowSearch(true);
                      }}
                    />
                  </div>
                  <div className="col col-w-full py-4 lg:py-0 lg:col-w-1/2">
                    <AgencyWelcomePanel
                      to="/request-for-proposal"
                      image="/img/agency-welcome/agency-welcome-images--brief.jpg"
                      subtitle="Start by entering your enquiry details then head to search"
                      title="Add a Brief"
                    />
                  </div>

                </div>
                {showSearch && (
                  <div ref={searchRef} className="py-4">
                    <SearchBannerNew text={<h4 className="text-shadow text-white text-1rem md:text-3xl">
                      Search for a venue
                    </h4>}/>
                  </div>
                )}
                <div className="row py-0 lg:py-4">
                  <div className="col col-w-full lg:col-w-1/3 mb-4 md:mb-0">
                    <AgencyWelcomePanel
                      to="/worldwide-venue-locations"
                      image="/img/agency-welcome/agency-welcome-images--international.jpg"
                      subtitle="Explore venues and destinations worldwide"
                      title="Go Global"
                    />
                  </div>
                  <div className="col col-w-full py-4 lg:py-0 lg:col-w-1/3">
                    <AgencyWelcomePanel
                      to="/corporate/news/venue-news"
                      image="/img/agency-welcome/agency-welcome-images--news.jpg"
                      subtitle="Catch up on the latest venue and industry news"
                      title="What’s new"
                    />
                  </div>
                  <div className="col col-w-full py-4 lg:py-0 lg:col-w-1/3">
                    <AgencyWelcomePanel
                      to="/news/special-offers"
                      image="/img/agency-welcome/agency-welcome-images--offers.jpg"
                      subtitle="All venue offers available on EDGE"
                      title="Latest Venue Offers"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

    </Fragment>
  )


}

const mapStateToProps = state => {
  return {
    ...state.selectedAgencies,
    user: user(state),
    agency: agencyObject(state.auth),
    showSnapshot: isHeadOfEvents(state.auth) || isHeadOfProcurement(state.auth),
    canAccessAgencyCalendar: agencyHasFeature(
      state.auth,
      AGENCY_PERMISSIONS.CAN_VIEW_AGENTS_CALENDAR
    ),
    canAccessCorporateCalendar:  canAccessCorporateCalendar(state.auth) && isHeadOfEvents(state.auth),
    canAccessAgencyDashboardSnapshot: agencyHasFeature(
      state.auth,
      AGENCY_PERMISSIONS.CAN_VIEW_AGENCY_DASHBOARD_SNAPSHOT
    ),
    token: token(state),
  };
};

export default connect(mapStateToProps, null)(CorporateWelcome);